import React, { useState } from 'react';
import styles from '../styles/scroller.module.css';
import { useFrame } from '@react-three/fiber';

function Scroller() {
    const [showScroll, setShowScroll] = useState(true);

    const checkScrollTop = () => {
        const element = document.getElementById('scroller');
        if (!element) return 0; // Return 0 if the element is not found
        const rect = element.getBoundingClientRect();

        return -rect.top;
    }
    
    useFrame(() => {
        const scrollTop = checkScrollTop();
        if(scrollTop >= 150){
            setShowScroll(!true);
        } else {
            setShowScroll(true);
        }
    })

    return (
        <div id="scroller" style={{
            width: "100vw",
            height: "100vh",
            position: "relative",
            transition: "opacity 1s ease-out"
        }} className={showScroll ? styles.fadeIn : styles.fadeOut}>
            <p className={styles.scrollDown}>Scroll to See More</p>
            <svg className={styles.arrows}>
                <path className={styles.a1} d="M0 0 L30 32 L60 0"></path>
                <path className={styles.a2} d="M0 20 L30 52 L60 20"></path>
                <path className={styles.a3} d="M0 40 L30 72 L60 40"></path>
            </svg>
        </div>
    )
};

export default Scroller;